exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kqpz .el-form-item__error{position:absolute!important;top:100%!important;left:29%!important}", ""]);

// exports
